import { useField, useFormikContext } from "formik"
import { FullWidthSpace, Table } from "melco-ui"
import { ThreadSupplierProductSelect } from "../select/ThreadSupplierProductSelect"
import { ThreadPublishedSupplierSelect } from "../select/ThreadPublishedSupplierSelect"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import React from "react"

export const FullWidthSelectWrapper = styled.div`
  width: 100%;

  .ant-select {
    width: 100% !important;
  }

  .ant-select-selector {
    width: 100% !important;
    display: flex;
    align-items: center;
  }

  .ant-select-selection-item {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ant-select-selection-placeholder {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ThreadColorsTab = () => {
    const [{ value: threadColors }] = useField<any[]>("thread_chart_color_list")
    const { setFieldValue, values, status } = useFormikContext();
    const { t } = useTranslation()

    const columns = React.useMemo(() => [
        {
            title: t("managethreads.tabs.colors.table.columns.name"),
            key: "name",
            dataIndex: "name",
            width: 50
        },
        {
            title: t("managethreads.tabs.colors.table.columns.code"),
            key: "code",
            dataIndex: "code",
            width: 50
        },
        {
            title: t("managethreads.tabs.colors.table.columns.color"),
            render: (rowObj: any) => <>{rowObj?.color?.argb ? "#" + rowObj?.color?.argb : ""}</>,
            width: 50
        }
        , {
            title: t("managethreads.tabs.colors.table.columns.supplier"),
            key: "supplier_id",
            width: 150,
            render: (_: any, rowObj: any, index: any) => {

                console.log(rowObj?.supplier_id)
                return (<>
                    <FullWidthSelectWrapper>
                        <ThreadPublishedSupplierSelect
                            value={rowObj?.supplier_id}
                            name={`thread_chart_color_list.${index}.supplier_id`}
                            onChange={(val) => {

                                setFieldValue(`thread_chart_color_list.${index}.product_id`, undefined)
                                // updateField(index, "supplier_id", val);
                                //updateField(index, "product_id", undefined); // reset dependent field

                            }}
                        />

                    </FullWidthSelectWrapper>
                </>)
            }
        }, {
            title: t("managethreads.tabs.colors.table.columns.type"),
            key: "product_id",
            width: 150,
            render: (_: any, rowObj: any, index: any) => <>{

                <FullWidthSelectWrapper>
                    {rowObj?.supplier_id && <ThreadSupplierProductSelect
                        name={`thread_chart_color_list.${index}.product_id`}
                        supplier_id={rowObj?.supplier_id}
                    // value={rowObj?.product_id}
                    // onChange={(val) => updateField(index, "product_id", val)}
                    />
                    }
                </FullWidthSelectWrapper>
            }
            </>
        }
    ], [t, setFieldValue]);

    return <>

        <FullWidthSpace size="small" direction="vertical">

            <Table
                showSorterTooltip={false}
                dataSource={threadColors}
                columns={columns}
                rowKey="code"
                pagination={false}
                noDataMessage={t("managethreads.tabs.colors.table.columns.no_colors_message")}
            //rowSelection={rowSelection}
            />

        </FullWidthSpace>
    </>
}